import apiWrapper from 'Helpers/apiWrapper'

const endpoints = ((baseURL) => {
  /* eslint-disable prettier/prettier */
  return {
    getAccountConfiguration: `${baseURL}/api/account/configuration`,
    getAccountCustomSettings: `${baseURL}/api/account/customsettings`,
    getAccountStatus: `${baseURL}/api/account/status`,
    getUserById: (idUser) =>
      `${baseURL}/api/user/${encodeURIComponent(idUser)}`,
    getOptionByShortName: (shortName) =>
      `${baseURL}/api/option/${encodeURIComponent(shortName)}`,
    getOptions: `${baseURL}/api/options`,
    getUserSetting: (idList, dataKey) =>
      `${baseURL}/api/usersettings/list/${encodeURIComponent(idList)}/${encodeURIComponent(dataKey)}`,
    upsertUserSettings: (idList, dataKey) =>
      `${baseURL}/api/usersettings/list/${encodeURIComponent(idList)}/${encodeURIComponent(dataKey)}`,
    deleteUserSetting: (idList, dataKey) =>
      `${baseURL}/api/usersettings/list/${encodeURIComponent(idList)}/${encodeURIComponent(dataKey)}`,
    getAccountDataRetention: () => `${baseURL}/api/account/dataretention`,
  }
  /* eslint-enable prettier/prettier */
})(process.env.BEACCOUNTS_URL)

export const beAccountsApiGetAccountConfiguration = () => {
  const url = endpoints.getAccountConfiguration
  return apiWrapper({
    method: 'get',
    url: url,
  }).then((res) => res.data)
}

export const beAccountsApiGetAccountCustomSettings = () => {
  const url = endpoints.getAccountCustomSettings

  return apiWrapper({
    method: 'get',
    url: url,
  }).then((res) => res.data)
}

export const beAccountsApiGetAccountStatus = () => {
  const url = endpoints.getAccountStatus

  return apiWrapper({
    method: 'get',
    url: url,
  }).then((res) => res.data)
}

export const beAccountsApiGetUserById = (idUser = 0) => {
  const url = endpoints.getUserById(idUser)

  return apiWrapper({
    method: 'get',
    url: url,
  }).then((res) => res.data)
}

export const beAccountsApiGetOptionByShortName = (shortName) => {
  const url = endpoints.getOptionByShortName(shortName)

  return apiWrapper({
    method: 'get',
    url: url,
  }).then((res) => res.data)
}

export const beAccountsApiGetUserSetting = (idList, dataKey) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getUserSetting(idList, dataKey),
  }).then(({ data }) => data)
}

export const beAccountsApiUpsertUserSettings = (idList, dataKey, DataValue) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.upsertUserSettings(idList, dataKey),
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ DataValue: JSON.stringify(DataValue) }),
  }).then(({ data }) => data)
}

export const beAccountsApiDeleteUserSetting = (idList, dataKey) => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.deleteUserSetting(idList, dataKey),
  }).then(({ data }) => data)
}

export const beAccountsGetAccountDataRetention = () => {
  const url = endpoints.getAccountDataRetention()

  return apiWrapper({
    method: 'get',
    url: url,
  }).then(({ data }) => data)
}

export const beAccountsApiGetOptions = (options) => {
  const url = endpoints.getOptions
  return apiWrapper({
    method: 'post',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ ShortNames: options }),
  }).then(({ data }) => data)
}
